const getPositivePage = (value) => {
  const page = Number(value);
  return Number.isSafeInteger(page) && page > 0 ? page : null;
};

export const getMailPageFromLocation = (location = {}) => {
  const searchParams = new URLSearchParams(location.search || '');
  const queryPage = getPositivePage(searchParams.get('page'));
  const statePage = getPositivePage(location.state?.mailParams?.page);

  return queryPage || statePage || 1;
};

export const updateMailPageSearch = (search = '', page = 1) => {
  const searchParams = new URLSearchParams(search);
  const nextPage = getPositivePage(page) || 1;

  if (nextPage > 1) {
    searchParams.set('page', `${nextPage}`);
  } else {
    searchParams.delete('page');
  }

  const nextSearch = searchParams.toString();
  return nextSearch ? `?${nextSearch}` : '';
};

export const buildMailReturnPath = ({ pathname, search = '', page = 1 }) =>
  `${pathname}${updateMailPageSearch(search, page)}`;

export const resolveMailReturnPath = ({ returnTo, fallbackPath, mailParams }) => {
  const fallbackPage = getPositivePage(mailParams?.page) || 1;
  const fallbackReturnPath = buildMailReturnPath({ pathname: fallbackPath, page: fallbackPage });

  if (typeof returnTo !== 'string' || !returnTo) return fallbackReturnPath;

  const hashIndex = returnTo.indexOf('#');
  const returnWithoutHash = hashIndex >= 0 ? returnTo.slice(0, hashIndex) : returnTo;
  const queryIndex = returnWithoutHash.indexOf('?');
  const pathname = queryIndex >= 0 ? returnWithoutHash.slice(0, queryIndex) : returnWithoutHash;

  if (pathname !== fallbackPath) return fallbackReturnPath;

  const search = queryIndex >= 0 ? returnWithoutHash.slice(queryIndex) : '';
  const page = getMailPageFromLocation({ search, state: { mailParams } });
  return buildMailReturnPath({ pathname: fallbackPath, search, page });
};
